// extracted by mini-css-extract-plugin
export default {"messageContainer":"MemberItem_messageContainer__wBV72","profileImage":"MemberItem_profileImage__KEn1y","name":"MemberItem_name__U753C","position":"MemberItem_position__cYklb"};